import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import '../style/HelpTip.scss';
import { t } from '../i18n';

let counter = 0;

// Petite aide contextuelle : un « ? » qui explique un réglage au survol et au focus clavier.
// <HelpTip text="Explication courte…" />
export default function HelpTip({ text }) {
  const id = React.useRef(`tsk-tip-${(counter += 1)}`).current;
  return (
    <span className='tsk-helptip'>
      <button type='button' className='tsk-helptip__btn' aria-describedby={id} aria-label={t('ui.help.tip')}>
        <FontAwesomeIcon icon={['fas', 'question-circle']} />
      </button>
      <span role='tooltip' id={id} className='tsk-helptip__bubble'>{text}</span>
    </span>
  );
}
